export default __webpack_public_path__ + "static/media/setting-banner.ecf1efa6.png";